import FormNovaCompensacaoFeriado from '@/templates/ManutencaoDoPonto/Digitacao/forms/NovaCompensacaoFeriado'
import { TRCompensacaoFeriado } from '@acme/core'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useAusenciasOutletContext } from 'pages/Ausencias'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { CompensacaoDia, compensacaoFeriados } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import IconeCadeado from './IconeCadeado'
import invalidateAusenciasQuery from './invalidateAusenciasQuery'

export default function EditarCompensacaoFeriado() {
    const { id } = useParams()
    const { data, competencia } = useAusenciasOutletContext()
    const { mutateAsync } = compensacaoFeriados.mutations.useUpdate()
    const empresa = useStore(state => state.company)
    const isEdicaoBloqueada = empresa?.competenciaAtual !== competencia
    const row = data?.find(
        a => a.id === 'compensacao-feriado_' + id,
    ) as TRCompensacaoFeriado
    if (!row || !empresa) return null

    const handleSubmit: SubmitHandler<CompensacaoDia> = data =>
        mutateAsync(
            {
                ...data,
                id: Number(String(row.id).split('_').at(-1)),
                dataFeriado: dayjs(data.dataFeriado).toDate(),
                dataCompensacao: dayjs(data.dataCompensacao).toDate(),
            },
            {
                onSuccess: async () => {
                    await invalidateAusenciasQuery()
                    toast.success('Compensação de feriado editada com sucesso!')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            defaultValues={row}
            onSubmit={isEdicaoBloqueada ? undefined : handleSubmit}
            height="auto"
            disableFields={isEdicaoBloqueada}
            open={hasPermission(['update', 'CompensaçãoDeFeriados'])}
        >
            <Dialog.Title>
                Editar compensação de feriado{' '}
                {isEdicaoBloqueada && <IconeCadeado />}
            </Dialog.Title>
            <Dialog.Content dividers>
                <FormNovaCompensacaoFeriado />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
